export interface ApiError {
  status: number;
  code: string;
  message: string;
  details?: Record<string, string[]>;
}

const apiErrorHandledKey = Symbol('apiErrorHandled');

type ApiErrorWithMeta = ApiError & {
  [apiErrorHandledKey]?: true;
};

export function isApiError(value: unknown): value is ApiError {
  if (!isRecord(value)) {
    return false;
  }

  const details = value['details'];

  return typeof value['status'] === 'number'
    && typeof value['code'] === 'string'
    && typeof value['message'] === 'string'
    && (details === undefined || isDetailsRecord(details));
}

export function markApiErrorHandled(error: ApiError): ApiError {
  const apiError = error as ApiErrorWithMeta;

  if (!apiError[apiErrorHandledKey]) {
    Object.defineProperty(apiError, apiErrorHandledKey, {
      value: true,
      configurable: true,
      enumerable: false,
      writable: true,
    });
  }

  return error;
}

export function hasHandledUserVisiblePath(error: unknown): boolean {
  return isApiError(error) && Boolean((error as ApiErrorWithMeta)[apiErrorHandledKey]);
}

function isDetailsRecord(value: unknown): value is Record<string, string[]> {
  if (!isRecord(value)) {
    return false;
  }

  return Object.values(value).every((entry) =>
    Array.isArray(entry) && entry.every((item) => typeof item === 'string')
  );
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
